const ImageCard = ({ card, big = false }) => {
  return (
    <div className={big ? "card-big" : "card"}>
      <img src={card.src} alt={card.alt} style={{ pointerEvents: "none" }} />
    </div>
  );
};

export default ImageCard;
